import type { STOCK_ALLOCATE_MODE_OPT } from '@/constants'

export enum SettingCode {
  notify = 'notify',
  'stock_warn' = 'stock_warn',
  'statistics_monitor_setting' = 'statistics_monitor_setting',
  'outbound_search_shortcut' = 'outbound_search_shortcut',
  'stock_sync_switch' = 'stock_sync_switch',
  'notification_scenes' = 'notification_scenes',
  /** 分配模式 */
  'stock_allocate_mode_setting' = 'stock_allocate_mode_setting',
  /** 同步频率 */
  'stock_sync_frequency_mode' = 'stock_sync_frequency_mode',
  /** 库存明细导出勾选字段 */
  'stock_export_columns' = 'stock_export_columns',
}

export interface ISettingParams {
  settingCode: SettingCode
}

export interface ISetting<T = any> {
  settingCode: SettingCode
  dataValue: T
}

// -----------> 同步频率 start

export interface SyncFrequencyModeUpdateReq {
  /**库存同步频率 STOCK_INCREMENT_SYNC( "stock_increment_sync","库存增量同步" ),TIMED_FULL_COVERAGE( "timed_full_coverage","定时全量同步，带有同步时间段配置" ) */
  syncFrequencyMode?: string
  /**时间段 */
  syncTimePeriods?: string[]
}

// -----------> 同步频率 end

// ---------> 批量查询商家配置 start
export interface SellerSettingListReqDTO {
  /**语言 */
  language?: string
  /**配置编码（约束：元素个数范围：[1,2147483647]） */
  settingCodes: SettingCode[]
}

export type StockSyncSwitch = boolean

export type StockSyncFrequencyMode = {
  syncFrequencyMode: string
  syncTimePeriods: string
}

export type StockAllocateModeSetting = {
  stockAllocateMode: (typeof STOCK_ALLOCATE_MODE_OPT)[number]['value']
}

interface SellerSettingRespDTO {
  /**配置编码 */
  settingCode?: string
  /**配置值 */
  dataValue?: StockSyncSwitch | StockSyncFrequencyMode | StockAllocateModeSetting
}

export interface BatchGetRes {
  /**配置 */
  list?: SellerSettingRespDTO[]
}

// -----------> 批量查询商家配置end
